import { StackHorizontalChart } from "../ChartJs";
import React from "react";
import { LongText, Unit } from "../processors";
import { CategoryTheme } from "../misc";
import { getTraceColors } from "../../themes";
import { Paragraph } from "../Paragraph";
import _ from "lodash";

export interface StackHorBarWithDataProps {
    unit?: Unit;
    data?: { value; label; seriesName }[];
    theme?: CategoryTheme;
    header?: LongText;
    footer?: LongText;
    emptyMessage?: string;
}

export const StackHorBarWithData: React.FC<StackHorBarWithDataProps> = ({ data, unit, header, footer, theme }) => {
    if (!data || !data.length) return null;

    const sum = _.sum((data ?? []).map(d => d.value ?? 0));
    if (sum === 0) return null;

    return (
        <>
            {header != null && (
                <Paragraph
                    nid={0}
                    status={true}
                    title={""}
                    text={header}
                    className={`marginBottom headline chart-headline`}
                />
            )}
            <StackHorizontalChart
                values={(data ?? []).map(d => d.value)}
                labels={(data ?? []).map(d => d.label)}
                colors={getTraceColors(
                    theme,
                    data?.length,
                    (data ?? []).map(d => d.label)
                )}
                unit={unit}
            />
            {footer != null && <Paragraph nid={0} status={true} title={""} text={footer} />}
        </>
    );
};
